import React from 'react';
import { JoyAiV2 } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { Box, Flex, TextV2 } from '@withjoy/joykit';

import { LottiePlayer } from '@shared/components/LottiePlayer';
import { VerticalScrollMessages } from '@shared/components/VerticalScrollMessages';

const LOADER_ANIMATION_ICON = 'https://heygirl.cutestperson.com/assets/public/apps/travel/lotties/accom-console-loader-texts.json';

type ConsoleLoaderProps = Readonly<{
  title: string;
  messages: ReadonlyArray<string>;
}>;

export const ConsoleLoader = ({ title, messages }: ConsoleLoaderProps) => (
  <Flex
    width="100%"
    height="100%"
    alignItems="center"
    flexDirection="column"
    justifyContent="center"
    maxWidth={pxToRem(388)}
  >
    <Box
      width={pxToRem(150)}
      height={pxToRem(150)}
    >
      <LottiePlayer
        play
        loop
        containerStyle={{
          margin: 'auto',
          width: pxToRem(150),
          height: pxToRem(150),
        }}
        lottieUrl={LOADER_ANIMATION_ICON}
      />
    </Box>
    <TextV2
      textAlign="center"
      maxWidth={pxToRem(388)}
      typographyVariant="hed6"
    >
      {title}
    </TextV2>
    <Flex width="100%">
      <Flex
        gap={4}
        marginTop={9}
        alignItems="center"
      >
        <JoyAiV2 size={32} />
        <VerticalScrollMessages
          messages={messages}
          shouldPauseOnMessage
          height={pxToRem(240)}
        />
      </Flex>
    </Flex>
  </Flex>
);
